import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  open: boolean
  title: string
  description: string
  confirmLabel?: string
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
}

/** Общий диалог подтверждения удаления (п.25 бэк-лога): одна точка на три
 *  вызывающих (плашка урока, миниатюра блока, шапка панели блока) — иначе
 *  тексты трёх копий разъедутся. Заголовок обязан называть ПРЕДМЕТ
 *  удаления — «Удалить?» без предмета не спасает от мисклика. */
export const DeleteConfirmDialog = ({
  open,
  title,
  description,
  confirmLabel,
  onOpenChange,
  onConfirm,
}: Props) => {
  const m = useMessages(messages)
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{m.cancel}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {confirmLabel ?? m.delete}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
